import {
    DateRangeMetadataEventArgs,
    Id3MetadataEventArgs,
    MediaItem,
    MediaMetadataEventArgs,
    MetadataType,
    MetaEventArgs,
    ProgramDateTimeMetadataEventArgs,
    Scte35MetadataEventArgs,
    UnknownMetadataEventArgs,
} from './media-player';

export namespace TypeGuards {

    // media playlist
    export function isMediaSource(arg: any): arg is MediaSource {
        return 'file' in arg && typeof arg.file === 'string';
    }

    export function isMediaSourceArray(arg: any): arg is MediaSource[] {
        const isArray: boolean = (arg instanceof Array);
        const ofSources: boolean = arg.length === arg.filter(s => isMediaSource(s)).length;
        return isArray && ofSources;
    }

    export function isMediaItem(arg: any): arg is MediaItem {
        const hasMediaId: boolean = (arg && 'mediaid' in arg && typeof arg.mediaid === 'string');
        const hasSources: boolean = (arg && 'sources' in arg && isMediaSourceArray(arg.sources));
        return hasMediaId && hasSources;
    }

    export function isMediaPlaylist(arg: any): arg is MediaItem[] {
        const isArray: boolean = arg instanceof Array;
        return isArray && (arg.length === arg.filter(i => isMediaItem(i)).length);
    }

    // metadata events
    export function isDateRangeMetadataEventArgs(arg: MetaEventArgs): arg is DateRangeMetadataEventArgs {
        return arg.metadataType === MetadataType.DateRange;
    }

    export function isMediaMetadataEventArgs(arg: MetaEventArgs): arg is MediaMetadataEventArgs {
        return arg.metadataType === MetadataType.Media;
    }

    export function isId3MetadataEventArgs(arg: MetaEventArgs): arg is Id3MetadataEventArgs {
        return arg.metadataType === MetadataType.Id3;
    }

    export function isUnknownMetadataEventArgs(arg: MetaEventArgs): arg is UnknownMetadataEventArgs {
        return arg.metadataType === MetadataType.Unknown;
    }

    export function isProgramDateTimeMetadataEventArgs(arg: MetaEventArgs): arg is ProgramDateTimeMetadataEventArgs {
        return arg.metadataType === MetadataType.ProgramDateTime;
    }

    export function isScte35MetadataEventArgs(arg: MetaEventArgs): arg is Scte35MetadataEventArgs {
        return arg.metadataType === MetadataType.Scte35;
    }

}


